module.exports = __webpack_public_path__ + "static/media/tree_17.86c1ff27.jpg";